import { Routes } from '@angular/router';
import { authGuard, adminGuard } from './guards/auth.guard';
import { LoginPage } from './pages/login.page';
import { ShellPage } from './pages/shell.page';
import { CampaignsPage } from './pages/campaigns.page';
import { CampaignDetailPage } from './pages/campaign-detail.page';
import { DataSourcesPage } from './pages/data-sources.page';
import { UsersPage } from './pages/users.page';
import { OperationsPage } from './pages/operations.page';
import { TestCallPage } from './pages/test-call.page';
import { CallHistoryPage } from './pages/call-history.page';
import { LeadsPage } from './pages/leads.page';

import { CostsPage } from './pages/costs.page';

export const routes: Routes = [
  { path: 'login', component: LoginPage },
  {
    path: '',
    component: ShellPage,
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'operations' },
      { path: 'operations', component: OperationsPage },
      { path: 'costs', component: CostsPage },
      { path: 'test-call', component: TestCallPage },
      { path: 'call-history', component: CallHistoryPage },
      { path: 'leads', component: LeadsPage },
      { path: 'campaigns', component: CampaignsPage },
      { path: 'campaigns/:id', component: CampaignDetailPage },
      { path: 'data-sources', component: DataSourcesPage },
      { path: 'users', component: UsersPage, canActivate: [adminGuard] },
    ],
  },
  { path: '**', redirectTo: 'operations' },
];
